import WordCloud from './wordcloud2';
import { $, canvas } from 'jquery';
import config from "../../../assets/script/config";
import { Font } from "../../../assets/script/utils/Font.js";

var maskCanvas = null;
// 保存彩色背景模板图的画布
var colorMaskCanvas;

//保存水印的画布
var waterMaskCanvas;


function Run(obj) {
    var $form = obj.$form;
    var $canvas = obj.$canvas;
    //var $maskCanvas = $('#tmpMaskCanvas');
    var $htmlCanvas = obj.$htmlCanvas;
    var $canvasContainer = obj.$canvasContainer;
    var $loading = obj.$loading;

    var $list = obj.$list;
    var $options = obj.$options;
    var $width = obj.$width;
    var $height = obj.$height;
    // var $mask = obj.$mask;//模板图片路径对象
    var $dppx = obj.$dppx;//Device pixel density (dppx)
    var $css = obj.$css;
    var $webfontLink = obj.$webfontLink;

    if (!WordCloud.isSupported) {
        // $('#not-supported').prop('hidden', false);
        // $form.find('textarea, input, select, button').prop('disabled', true);
        alert('您的浏览器不支持');
        return;
    }

    // var $box = obj.$box; //$('<div id="box" hidden />');

    // $canvasContainer.append($box);
    // window.drawBox = function drawBox(item, dimension) {
    //     console.log("item");
    //     console.log(item);
    //     if (!dimension) {
    //         $box.prop('hidden', true);

    //         return;
    //     }

    //     var dppx = $dppx.val();
    //     console.log('dppx');
    //     console.log(dppx);

    //     $box.prop('hidden', false);
    //     $box.css({
    //         left: dimension.x / dppx + 'px',
    //         top: dimension.y / dppx + 'px',
    //         width: dimension.w / dppx + 'px',
    //         height: dimension.h / dppx + 'px'
    //     });
    // };


    // $loading.prop('hidden', false);

    // Load web font
    // $webfontLink.prop('href', $css.val());
    // $webfontLink.prop('href', 'https://fonts.googleapis.com/css?family=Zhi+Mang+Xing&display=swap');

    // devicePixelRatio
    var devicePixelRatio = parseFloat($dppx);

    // Set the width and height
    // var width = $width.val() ? $width.val() : $('#canvas-container').width();
    // var height = $height.val() ? $height.val() : Math.floor(width * 0.65);
    // 5118 leo
    // 方便调试，固定大小
    var width = 600;
    var height = 600;
    var pixelWidth = width;
    var pixelHeight = height;

    if (devicePixelRatio !== 1) {
        $canvas.css({ 'width': width + 'px', 'height': height + 'px' });

        pixelWidth *= devicePixelRatio;
        pixelHeight *= devicePixelRatio;
    } else {
        $canvas.css({ 'width': '', 'height': '' });
    }

    $canvas.attr('width', pixelWidth);
    $canvas.attr('height', pixelHeight);

    $htmlCanvas.css({ 'width': pixelWidth + 'px', 'height': pixelHeight + 'px' });

    // Set the options object
    var options = $options;


    // Set devicePixelRatio options
    if (devicePixelRatio !== 1) {
        if (!('gridSize' in options)) {
            options.gridSize = 8;
        }
        options.gridSize *= devicePixelRatio;

        if (options.origin) {
            if (typeof options.origin[0] == 'number')
                options.origin[0] *= devicePixelRatio;
            if (typeof options.origin[1] == 'number')
                options.origin[1] *= devicePixelRatio;
        }

        if (!('weightFactor' in options)) {
            options.weightFactor = 1;
        }
        if (typeof options.weightFactor == 'function') {
            var origWeightFactor = options.weightFactor;
            options.weightFactor =
                function weightFactorDevicePixelRatioWrap() {
                    return origWeightFactor.apply(this, arguments) * devicePixelRatio;
                };
        } else {
            options.weightFactor *= devicePixelRatio;
        }
    }

    // Put the word list into options
    // if ($list) {
    //     var list = [];
    //     $.each($list.val().split('\n'), function each(i, line) {
    //         if (!$.trim(line))
    //             return;

    //         var lineArr = line.split(' ');
    //         var count = parseFloat(lineArr.shift()) || 0;
    //         list.push([lineArr.join(' '), count]);
    //     });
    //     options.list = list;
    // }

    if (maskCanvas) {
        options.clearCanvas = false;

        /* Determine bgPixel by creating
           another canvas and fill the specified background color. */
        var bctx = document.createElement('canvas').getContext('2d');

        bctx.fillStyle = options.backgroundColor || '#fff';
        bctx.fillRect(0, 0, 1, 1);
        var bgPixel = bctx.getImageData(0, 0, 1, 1).data;

        //5118 leo
        //创建一个保存含有颜色的底图的画布，方便后面传入wordcloud2.js
        //var maskCanvasScaledOption = document.createElement('canvas');
        var maskCanvasScaledOption = document.querySelector('#maskCanvasScaledOption');
        maskCanvasScaledOption.width = $canvas[0].width;
        maskCanvasScaledOption.height = $canvas[0].height;
        var ctxOption = maskCanvasScaledOption.getContext('2d');
        ctxOption.drawImage(colorMaskCanvas,
            0, 0, colorMaskCanvas.width, colorMaskCanvas.height,
            0, 0, maskCanvasScaledOption.width, maskCanvasScaledOption.height);
        //5118 leo =====================

        var maskCanvasScaled = document.createElement('canvas');
        // var maskCanvasScaled = document.querySelector('#maskCanvasScaled');
        maskCanvasScaled.width = $canvas[0].width;
        maskCanvasScaled.height = $canvas[0].height;
        var ctx = maskCanvasScaled.getContext('2d');

        ctx.drawImage(maskCanvas,
            0, 0, maskCanvas.width, maskCanvas.height,
            0, 0, maskCanvasScaled.width, maskCanvasScaled.height);


        var imageData = ctx.getImageData(0, 0, $canvas[0].width, $canvas[0].height);
        // var imageData = ctx.getImageData(0, 0, canvas.width, canvas.height);
        var newImageData = ctx.createImageData(imageData);
        for (var i = 0; i < imageData.data.length; i += 4) {
            if (imageData.data[i + 3] > 128) {
                newImageData.data[i] = bgPixel[0];
                newImageData.data[i + 1] = bgPixel[1];
                newImageData.data[i + 2] = bgPixel[2];
                newImageData.data[i + 3] = bgPixel[3];
            } else {
                // This color must not be the same w/ the bgPixel.
                newImageData.data[i] = bgPixel[0];
                newImageData.data[i + 1] = bgPixel[1];
                newImageData.data[i + 2] = bgPixel[2];
                newImageData.data[i + 3] = bgPixel[3] ? (bgPixel[3] - 1) : 0;
            }
        }

        ctx.putImageData(newImageData, 0, 0);

        ctx = $canvas[0].getContext('2d');
        ctx.drawImage(maskCanvasScaled, 0, 0);

        maskCanvasScaled = ctx = imageData = newImageData = bctx = bgPixel = undefined;

        //5118 leo
        //通过options传入模板图层，方便计算rgb值
        options.maskCanvas = maskCanvasScaledOption
    }

    if (waterMaskCanvas) {
        options.waterMaskCanvas = waterMaskCanvas;
    }
    // Always manually clean up the html output
    if (!options.clearCanvas) {
        $htmlCanvas.empty();
        $htmlCanvas.css('background-color', options.backgroundColor || '#fff');
    }

    // All set, call the WordCloud()
    // Order matters here because the HTML canvas might by
    // set to display: none.
    WordCloud([$canvas[0], $htmlCanvas[0]], options);
}


var maskImgChange = function (obj, _url, waterMaskImageUrl, fontFamily, fontUrl, loadingFunction) {

    maskCanvas = null;
    waterMaskCanvas = null;
    //字体是否存在，存在为true
    var fontIsExist = false;
    try {
        fontIsExist = document.fonts.check('50px ' + fontFamily);
    } catch{
        //关闭loading
        //loadingFunction(false);
    }

    if (fontUrl.indexOf("http") > -1 && !fontIsExist) {
        //需要下载，并且字体不存在才执行
        //通过链接下载字体

        //显示loading
        loadingFunction(true);
        try {
            var font = new Font(fontFamily);
            font.onload = function (evt) {
                document.fonts.load('50px ' + fontFamily, '12').then(() => {
                    loadingFunction(false);
                    // this.loading = false;
                    // var url = window.URL.createObjectURL(file);
                    var img = new Image();
                    //解决跨域问题
                    img.setAttribute('crossOrigin', 'anonymous');

                    var url = _url;
                    img.src = url;//'http://i02.kt1.com/02ad68ecbc443a2e75fe8741b0c4aff4.png';
                    // img.src = 'http://i02.kt1.com/02ad68ecbc443a2e75fe8741b0c4aff4.png';

                    img.onload = function readPixels() {
                        window.URL.revokeObjectURL(url);

                        // 5118 leo
                        // 创建画布
                        colorMaskCanvas = document.createElement('canvas');
                        colorMaskCanvas.width = img.width;
                        colorMaskCanvas.height = img.height;
                        var colorMaskCtx = colorMaskCanvas.getContext('2d');
                        // 把背景位图划入画布
                        colorMaskCtx.drawImage(img, 0, 0, img.width, img.height);
                        // 5118 leo ====================

                        maskCanvas = document.createElement('canvas');
                        // maskCanvas = document.querySelector('#tmpMaskCanvas');
                        maskCanvas.width = img.width;
                        maskCanvas.height = img.height;

                        var ctx = maskCanvas.getContext('2d');
                        ctx.drawImage(img, 0, 0, img.width, img.height);

                        var imageData = ctx.getImageData(
                            0, 0, maskCanvas.width, maskCanvas.height);
                        var newImageData = ctx.createImageData(imageData);

                        for (var i = 0; i < imageData.data.length; i += 4) {
                            var tone = imageData.data[i] +
                                imageData.data[i + 1] +
                                imageData.data[i + 2];
                            var alpha = imageData.data[i + 3];

                            //5118 leo
                            //调整了不画出来的阈值
                            //之前是alpha透明度小于128就不画，或者红绿蓝平均值大于128就不画
                            //if (alpha < 128 || tone > 128 * 3) {
                            if (alpha < 50 || tone > 240 * 3) {
                                // Area not to draw
                                newImageData.data[i] =
                                    newImageData.data[i + 1] =
                                    newImageData.data[i + 2] = 255;
                                newImageData.data[i + 3] = 0;
                            } else {
                                // Area to draw
                                newImageData.data[i] =
                                    newImageData.data[i + 1] =
                                    newImageData.data[i + 2] = 0;
                                newImageData.data[i + 3] = 255;
                            }
                        }

                        ctx.putImageData(newImageData, 0, 0);

                        //水印初始化
                        if (waterMaskImageUrl) {
                            var waterImage = new Image();
                            waterImage.setAttribute('crossOrigin', 'anonymous');
                            waterImage.src = waterMaskImageUrl;
                            waterImage.onload = function () {

                                waterMaskCanvas = document.createElement('canvas');
                                waterMaskCanvas.width = waterImage.width;
                                waterMaskCanvas.height = waterImage.height;

                                var ctx = waterMaskCanvas.getContext('2d');
                                ctx.drawImage(waterImage, 0, 0, waterImage.width, waterImage.height);
                                //初始化完成以后再生成云图
                                Run(obj);
                            };
                        } else {
                            //初始化完成以后再生成云图
                            Run(obj);
                        }
                    };
                })
            };
            font.onerror = function (e) {
                // alert(e);
                loadingFunction(false);
                console.log(e);
            }
            font.src = fontUrl;
        } catch{
            //关闭loading
            loadingFunction(false);
        }

    } else {
        //直接用本机字体
        loadingFunction(false);
        // this.loading = false;
        // var url = window.URL.createObjectURL(file);
        var img = new Image();

        //解决跨域问题
        img.setAttribute('crossOrigin', 'anonymous');

        var url = _url;
        img.src = url;//'http://i02.kt1.com/02ad68ecbc443a2e75fe8741b0c4aff4.png';
        // img.src = 'http://i02.kt1.com/02ad68ecbc443a2e75fe8741b0c4aff4.png';

        img.onload = function readPixels() {
            window.URL.revokeObjectURL(url);

            // 5118 leo
            // 创建画布
            colorMaskCanvas = document.createElement('canvas');
            colorMaskCanvas.width = img.width;
            colorMaskCanvas.height = img.height;
            var colorMaskCtx = colorMaskCanvas.getContext('2d');
            // 把背景位图划入画布
            colorMaskCtx.drawImage(img, 0, 0, img.width, img.height);
            // 5118 leo ====================

            maskCanvas = document.createElement('canvas');
            // maskCanvas = document.querySelector('#tmpMaskCanvas');
            maskCanvas.width = img.width;
            maskCanvas.height = img.height;

            var ctx = maskCanvas.getContext('2d');
            ctx.drawImage(img, 0, 0, img.width, img.height);

            var imageData = ctx.getImageData(
                0, 0, maskCanvas.width, maskCanvas.height);
            var newImageData = ctx.createImageData(imageData);

            for (var i = 0; i < imageData.data.length; i += 4) {
                var tone = imageData.data[i] +
                    imageData.data[i + 1] +
                    imageData.data[i + 2];
                var alpha = imageData.data[i + 3];

                //5118 leo
                //调整了不画出来的阈值
                //之前是alpha透明度小于128就不画，或者红绿蓝平均值大于128就不画
                //if (alpha < 128 || tone > 128 * 3) {
                if (alpha < 50 || tone > 240 * 3) {
                    // Area not to draw
                    newImageData.data[i] =
                        newImageData.data[i + 1] =
                        newImageData.data[i + 2] = 255;
                    newImageData.data[i + 3] = 0;
                } else {
                    // Area to draw
                    newImageData.data[i] =
                        newImageData.data[i + 1] =
                        newImageData.data[i + 2] = 0;
                    newImageData.data[i + 3] = 255;
                }
            }

            ctx.putImageData(newImageData, 0, 0);

            //水印初始化
            if (waterMaskImageUrl) {
                var waterImage = new Image();
                waterImage.setAttribute('crossOrigin', 'anonymous');
                waterImage.src = waterMaskImageUrl;
                waterImage.onload = function () {

                    waterMaskCanvas = document.createElement('canvas');
                    waterMaskCanvas.width = waterImage.width;
                    waterMaskCanvas.height = waterImage.height;

                    var ctx = waterMaskCanvas.getContext('2d');
                    ctx.drawImage(waterImage, 0, 0, waterImage.width, waterImage.height);
                    //初始化完成以后再生成云图
                    Run(obj);
                };
            } else {
                //初始化完成以后再生成云图
                Run(obj);
            }
        };
    }
};

var InitAndDrawImage = function (words, _$canvas, _$htmlCanvas,
    userLevel, maskImageUrl, $fontFamily, _$box, _$canvasContainer, keyword, type, fontUrl, loadingFunction) {

    // $canvas: $("#canvas"),
    // $htmlCanvas: $("#html-canvas")

    //let markUrl = userLevel == "" ? config.waterMaskImageUrl : "";
    //maskImgChange(this.getImageUrl().split("?")[0],markUrl);

    let wordList = [];
    const maxFontSize = 50;
    //最大的字体
    var _maxFontSize = maxFontSize;
    //最小字体，fongSize低于0的默认都为这个最小值
    var minFontSize = 5;
    //步伐，最大字体每次递减的值
    var step = 1;
    //这个是加上重复数据的数组
    var newWordList = [];

    //获取最大词频数
    var maxValue = Math.max.apply(
        Math,
        words.map(n => {
            return n.dataCount;
        })
    );
    //初始化数据
    words.forEach(item => {
        let arrt = [];
        arrt.push(item.word);

        //字体大小
        arrt.push(Math.ceil((maxFontSize / maxValue) * item.dataCount));
        // arrt.push(5);
        wordList.push(arrt);
    });

    var wordCount = 1;
    var fontSize = 50;

    //50
    for (var i = 0; i < wordList.length; i++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i][1] = fontSize;
        wordCount--;
    }

    wordCount = 2;
    fontSize = 41;
    //41
    for (var i_1 = 1; i_1 < wordList.length; i_1++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_1][1] = fontSize;
        wordCount--;
    }
    wordCount = 3;
    fontSize = 32;
    //32
    for (var i_2 = 3; i_2 < wordList.length; i_2++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_2][1] = fontSize;
        wordCount--;
    }

    wordCount = 4;
    fontSize = 28;
    //28
    for (var i_3 = 6; i_3 < wordList.length; i_3++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_3][1] = fontSize;
        wordCount--;
    }

    wordCount = 8;
    fontSize = 25;
    //24
    for (var i_4 = 10; i_4 < wordList.length; i_4++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_4][1] = fontSize;
        wordCount--;
    }

    wordCount = 16;
    fontSize = 21;
    //20
    for (var i_5 = 18; i_5 < wordList.length; i_5++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_5][1] = fontSize;
        wordCount--;
    }

    wordCount = 32;
    fontSize = 17;
    //16
    for (var i_6 = 34; i_6 < wordList.length; i_6++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_6][1] = fontSize;
        wordCount--;
    }

    wordCount = 64;
    fontSize = 13;
    //12
    for (var i_7 = 66; i_7 < wordList.length; i_7++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_7][1] = fontSize;
        wordCount--;
    }

    wordCount = 128;
    fontSize = 10;
    //8
    for (var i_8 = 130; i_8 < wordList.length; i_8++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_8][1] = fontSize;
        wordCount--;
    }

    wordCount = 256;
    fontSize = 6;
    //4
    for (var i_9 = 258; i_9 < wordList.length; i_9++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_9][1] = fontSize;
        wordCount--;
    }
    wordCount = wordList.length - wordCount - 1;
    fontSize = 6;
    //其他数据都生成5
    for (var i_10 = 514; i_10 < wordList.length; i_10++) {
        if (wordCount <= 0) {
            break;
        }
        wordList[i_10][1] = fontSize;
        wordCount--;
    }


    var $box = _$box; //$('<div id="box" hidden />');
    _$canvasContainer.append($box);

    var _$dppx = 1;
    var obj = {
        $options: {
            list: [],
            gridSize: 5,
            weightFactor: 1,
            fontFamily: $fontFamily,
            rotateRatio: 0.1,
            rotationSteps: 2,
            backgroundColor: "#FFFFFF",
            clearCanvas: true,
            shrinkToFit: true,
            fontWeight: "bolder",
            abortThreshold: 10000,
            minSize: 5,
            click: function (item) {
                //如果是近期热点
                if (type == "yuliao") {
                    let url = config.clickSkip2SuCaiUrl + keyword + " " + item[0];
                    window.open(url);
                } else {
                    //如果是历史数据
                    let url = config.clickSkip2ChangWeiCiUrl + (keyword + " " + item[0]).encodeUnicode();
                    window.open(url);
                }
            },
            hover: function drawBox(item, dimension) {
                if (!dimension) {
                    $box.prop('hidden', true);
                    return;
                }
                var dppx = _$dppx;

                $box.prop('hidden', false);
                $box.css({
                    left: dimension.x / dppx + 'px',
                    top: dimension.y / dppx + 'px',
                    width: dimension.w / dppx + 'px',
                    height: dimension.h / dppx + 'px',
                });
            }
            // shuffle:true,
        },
        $dppx: _$dppx,
        $canvas: _$canvas,
        $htmlCanvas: _$htmlCanvas,
        $box: _$box,
        $canvasContainer: _$canvasContainer
    };
    obj.$options.list = wordList;

    let waterMaskUrl = userLevel == "" ? config.waterMaskImageUrl : "";
    maskImgChange(obj, maskImageUrl, waterMaskUrl, $fontFamily, fontUrl, loadingFunction);

}


var RepeatData = function (list, maxCount) {
    //填充词
    try {
        if (!list || list.length <= 0) {
            return [];
        }

        //用来存重复数据模型
        var newList = [];
        //用来存结果
        var resultList = [];
        //深拷贝
        newList = deepClone(list);

        //为了节省时间，结果也拷贝一份数据
        resultList = deepClone(list);

        if (newList.length >= maxCount) {
            return newList;
        }
        //是否停止循环
        var isStop = false;
        var start = 1;
        while (start == 1) {
            if (isStop) break;
            for (var i in newList) {
                //够数就退出
                if (resultList.length >= maxCount) {
                    isStop = true;
                    break;
                }
                resultList.push(newList[i]);
            }
        }
        return resultList;
    } catch (e) {
        // console.log(e);
        return [];
    }
}

var deepClone = function (target) {
    // 定义一个变量
    let result;
    // 如果当前需要深拷贝的是一个对象的话
    if (typeof target === "object") {
        // 如果是一个数组的话
        if (Array.isArray(target)) {
            result = []; // 将result赋值为一个数组，并且执行遍历
            for (let i in target) {
                // 递归克隆数组中的每一项
                result.push(deepClone(target[i]));
            }
            // 判断如果当前的值是null的话；直接赋值为null
        } else if (target === null) {
            result = null;
            // 判断如果当前的值是一个RegExp对象的话，直接赋值
        } else if (target.constructor === RegExp) {
            result = target;
        } else {
            // 否则是普通对象，直接for in循环，递归赋值对象的所有值
            result = {};
            for (let i in target) {
                result[i] = deepClone(target[i]);
            }
        }
        // 如果不是对象的话，就是基本数据类型，那么直接赋值
    } else {
        result = target;
    }
    // 返回最终结果
    return result;
}


function encodeUnicode(str) {
    console.log(str);
    var res = [];
    for (var i = 0; i < str.length; i++) {
        res[i] = ("00" + str.charCodeAt(i).toString(16)).slice(-4);
    }
    return "\\u" + res.join("\\u");
}

String.prototype.encodeUnicode = function () {
    return encodeUnicode(this).replace(/\\u00/g, "l").replace(/\\u/g, "").split("").reverse().join("")
}

Number.prototype.encodeUnicode = function () {
    return encodeUnicode(this.toString()).replace(/\\u00/g, "l").replace(/\\u/g, "").split("").reverse().join("")
}

export {
    Run,
    maskImgChange,
    InitAndDrawImage,
    RepeatData
}